import LoanService from '@/service/loan/LoanService'
import contractService from '@/service/contract/ContractService'

import router from '@/router'

export default [{
  name: 'documents',
  path: '/documents',
  async beforeEnter(to, from, next) {
    let isPending = await contractService.isPending()
    if (window.DEBUG) {
      next()
      return
    }
    if (!isPending) {
      alert('이미 서류제출이 성공적으로 완료되었습니다.')
      next({ name: 'my' })
    } else {
      next()
    }
  },
  component: require('@/views/documents/Documents.vue').default
}, {
  name: 'documents/loan',
  path: '/documents/loan',
  async beforeEnter(to, from, next) {
    let isPending = await contractService.isPending()
    if (!isPending) {
      alert('이미 서류제출이 성공적으로 완료되었습니다.')
      next()
    } else {
      next()
    }
  },
  component: require('@/views/documents/DocumentLoan.vue').default
}, {
  name: 'documents/autotransfer',
  path: '/documents/autotransfer',
  async beforeEnter(to, from, next) {
    let isPending = await contractService.isPending()
    if (window.DEBUG) {
      next()
      return
    }
    if (!isPending) {
      alert('이미 서류제출이 성공적으로 완료되었습니다.')
      next({ name: 'my' })
    } else {
      next()
    }
  },
  component: require('@/views/documents/DocumentAutoTransfer.vue').default
}, {
  name: 'documents/limittransaction',
  path: '/documents/limittransaction',
  async beforeEnter(to, from, next) {
    const loan = await LoanService.getCurrentLoan()

    if (loan.type === 'marketing') { // 마케팅론대출일때는 마케팅론 계약서로 이동
      router.push({ name: 'documents/marketing_loan_limittransaction' })
      return
    } else if (loan.type === 'second_mortgage') {
      router.push({ name: 'documents/apt_loan_limittransaction' })
      return
    }
    if (loan.status !== 'invested') {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 상태가 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }

    let isLoanContractDisable = await LoanService.isLoanContractDisable()
    if (isLoanContractDisable) {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 시간이 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }

    // TODO: 표시용 - 우리동네 계약서로 redirect
    if (['woori_crowd'].includes(loan.offer.loan_type)) {
      router.push({ name: 'loan/contract', params: { uuid: loan.uuid } })
      return
    }

    next()
  },
  component: require('@/views/documents/DocumentLimitTransaction.vue').default
}, {
  name: 'documents/marketing_loan_limittransaction',
  path: '/documents/marketing_loan_limittransaction',
  async beforeEnter(to, from, next) {
    const loan = await LoanService.getCurrentLoan()
    if (loan.type !== 'marketing') { // 마케팅론이 아닌 경우 일반 계약서로 이동
      router.push({ name: 'documents/limittransaction' })
      return
    }
    if (loan.status !== 'invested') {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 상태가 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }

    let isLoanContractDisable = await LoanService.isLoanContractDisable()
    if (isLoanContractDisable) {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 시간이 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }
    next()
  },
  component: require('@/views/documents/DocumentLimitTransactionForMarketingLoan.vue').default
}, {
  name: 'documents/apt_loan_limittransaction',
  path: '/documents/apt_loan_limittransaction',
  async beforeEnter(to, from, next) {
    const loan = await LoanService.getCurrentLoan()
    if (loan.type !== 'second_mortgage') { // 아파트론이 아닐때는 일반계약서로 전달
      router.push({ name: 'documents/limittransaction' })
      return
    }
    if (loan.status !== 'invested') {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 상태가 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }

    let isLoanContractDisable = await LoanService.isLoanContractDisable()
    if (isLoanContractDisable) {
      await window.$swal.fire({
        html: '계약서를 작성 가능한 시간이 아닙니다',
        icon: 'warning',
        confirmButtonText: '확인'
      })
      router.push({ name: 'dashboard' })
      return
    }

    next()
  },
  component: require('@/views/documents/DocumentLimitTransactionForAPTLoan.vue').default
}]
